import { WORDPRESS_API } from "shared/constants/api";

export const insuranceDocuments = [
  {
    id: "warianty",
    title: "Warianty ubezpieczenia NNW",
    href: `${WORDPRESS_API}/wp-content/uploads/2026/08/Wybrane-warianty-z-OC-praktykanta.pdf`
  },
  // {
  //   id: "zglaszanie-swiadczen",
  //   title: "Zasady zgłaszania świadczeń",
  //   href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Zasady-zglaszania-swiadczen-w-PZU.pdf`
  // },
  // {
  //   id: "owu",
  //   title: "Ogólne warunki ubezpieczenia",
  //   href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Ogolne-Warunki-Ubezpieczenia-EDU-PLUS_2025_2026.pdf`
  // },
  {
    id: "oplata-skladki",
    title: "Zasady opłaty składki",
    href: `${WORDPRESS_API}/wp-content/uploads/2026/08/Zasady-oplaty-skladki_2026_2027.pdf`
  },
  {
    id: "opis-ubezpieczenia",
    title: "Opis ubezpieczenia - Uwagi i informacje dodatkowe",
    href: `${WORDPRESS_API}/wp-content/uploads/2026/09/Opis-ubezpieczenia-2026_2027.pdf`
  },
  {
    id: "zasady-zglaszania",
    title: "Zasady zgłaszania świadczeń",
    href: `${WORDPRESS_API}/wp-content/uploads/2026/09/Zasady-zglaszania-swiadczen.pdf`
  }
];